import React, { Component } from 'react';


class CustomizedDot extends Component {

    render() {
        const { cx, cy, fill } = this.props;
        return (
            <svg x={cx - 12.5} y={cy - 12.5} width={160} height={160} viewBox="0 0 1024 1024">
                <circle cx="80" cy="80" r="30" stroke="black" strokeWidth="3" fill={fill}
                    className='on-mouse-hover'
                />
            </svg>
        )
    }
}

export default CustomizedDot;

